import React, { useState, useEffect, useReducer, useRef } from "react";
import { Routes, Route, useNavigate, useLocation } from "react-router-dom";
import CartFullModal from "./machineUI/items/CartFullModal";
import Swal from "sweetalert2";
import Initial from "./machineUI/items/Initial";
import Home from "./machineUI/home";
import CategoryPage from "./machineUI/Category/CategoryPage";
import DescriptionPage from "./machineUI/Description/DescPage";
import { Helmet } from "react-helmet";

const LOCAL_STORAGE_KEY = "MagexApp.cart";
let MAXCARTNUM = 3;

const RouteUI = () => {
  const location = useLocation();
  const machineID = localStorage.getItem("machineID");
  const history = useNavigate();
  const [cartQuantity, setCartQuantity] = useState(0);
  const [langs, setlangs] = useState("en");
  const [cartFull, setCartFull] = useState(false);
  const [machine, setMachine] = useState(null);
  const [themeColor, setThemeColor] = useState({});
  const [showCart, setShowCart] = useState(false);
  const [products, setProds] = useReducer(productsReducer, []);

  const [cart, setCart] = useReducer(cartReducer, []);

  const productRef = useRef(0);
  const cartRef = useRef(0);
  const promoRef = useRef(0);
  const closePromoModalRef = useRef(0);

  useEffect(() => {
    const productsStock = JSON.parse(localStorage.getItem("products"));
    if (productsStock) {
      setProds({ productsStock, type: "set" });
    }
  }, []);

  useEffect(() => {
    localStorage.setItem("products", JSON.stringify(products));
    productRef.current = products;
  }, [products]);

  function productsReducer(state, action) {
    switch (action.type) {
      case "set":
        return [...action.productsStock];
      case "add":
        return [...action.product];
      case "clean": {
        const update = [];
        return update;
      }
      case "decrement": {
        const productIndex = state.findIndex(
          (item) => item._id === action.product._id
        );
        if (productIndex < 0) {
          return state;
        }

        if (
          cartQuantity < MAXCARTNUM ||
          action.product.current_stock < action.qtt
        ) {
          if (action.product.current_stock > action.qtt) {
            if (
              action.mycart?.length === 1 &&
              (action.mycart[0].promoType === "oneTime" ||
                action.mycart[0].promoType === "nextPurchase")
            )
              return state;
          }

          const update = [...state];
          update[productIndex].current_stock = action.qtt;

          console.log("update", update);

          return update;
        }
      }
      default:
        return state;
    }
  }

  function decreStock(product, qtt) {
    setProds({ product, qtt, mycart: cart, type: "decrement" });
  }

  function setAllProds(product) {
    setProds({ product, type: "add" });
  }

  function changeProdPrice(product) {
    setCart({ product, type: "changeProdPrice" });
  }

  useEffect(() => {
    const storedCart = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));
    if (storedCart) {
      setCart({ storedCart, type: "addArray" });
    }
  }, []);

  useEffect(() => {
    localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(cart));
    const totalQtt = cart.reduce((total, item) => {
      return (total += item.quantity);
    }, 0);
    setCartQuantity(totalQtt);
    cartRef.current = cart;
  }, [cart]);

  function cartReducer(state, action) {
    switch (action.type) {
      case "addArray": {
        return [...action.storedCart];
      }
      case "add": {
        if (cartQuantity >= MAXCARTNUM) {
          setCartFull(true);
          return state;
        } else {
          // if (action.product.category?.length > 0 && action.product.limit > 0) {
          //   let qqt = action.product.limit;
          //   state.forEach((pd) => {
          //     if (pd.category?.length > 0 && pd.category[0] === action.product.category[0]) {
          //       qqt -= pd.quantity;
          //     }
          //   });
          //   console.log('qqt', qqt);
          //   if (qqt <= 0) {
          //     Swal.fire({
          //       showConfirmButton: false,
          //       timer: 3000,
          //       timerProgressBar: true,
          //       text: `You can only purchase ${action.product.limit} item in this category.`,
          //       icon: 'error',
          //     });
          //     return state;
          //   }
          // }

          return [...state, action.product];
        }
      }
      case "remove": {
        const productIndex = state.findIndex(
          (item) => item.id === action.product.id
        );
        if (productIndex < 0) {
          return state;
        }
        const update = [...state];
        update.splice(productIndex, 1);
        return update;
      }
      case "chgQuantity": {
        const productIndex = state.findIndex(
          (item) => item.id === action.product.id
        );
        if (productIndex < 0) {
          return state;
        }
        if (
          state[productIndex].promoType === "oneTime" ||
          state[productIndex].promoType === "nextPurchase"
        ) {
          Swal.fire({
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            text: "One time code only allow to purcahse 1 item.",
            icon: "error",
          });
          return state;
        }
        if (
          cartQuantity >= MAXCARTNUM &&
          state[productIndex].quantity < action.quantity
        ) {
          setCartFull(true);
          return state;
        } else {
          const update = [...state];
          update[productIndex].quantity = action.quantity;
          return update;
        }
      }
      case "changePrice": {
        const productIndex = state.findIndex(
          (item) => item.id === action.product.id
        );
        if (productIndex < 0) {
          return state;
        }
        const update = [...state];
        update[productIndex].discount = action.discount;
        update[productIndex].discountedPrice = action.discountedPrice;
        update[productIndex].buyX = action.buyX;
        update[productIndex].percentage = action.percentage;
        update[productIndex].promo = action.promo;
        return update;
      }
      case "clean": {
        const update = [];
        return update;
      }
      case "getQuantity": {
        const cart = [...state];
      }
      default:
        return state;
    }
  }

  function add(product) {
    const funcAdd = () => {
      setCart({ product, type: "add" });
    };

    if (product?.pop_alert?.en) {
      let pop_alert = product.pop_alert[langs]
        ? product.pop_alert[langs]
        : product.pop_alert.en;
      Swal.fire({
        text: pop_alert,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        if (result.isConfirmed) {
          funcAdd();
        } else {
          return;
        }
      });
    } else {
      funcAdd();
    }
  }

  function remove(product) {
    setCart({ product, type: "remove" });
  }

  function alterQuantity(product, quantity, isIncrement) {
    setCart({ product, type: "chgQuantity", quantity: quantity });
  }

  function cleanUp() {
    setCart({ type: "clean" });
    // setProds({ type: 'clean' });
  }

  function changePrice(
    product,
    discount,
    discountedPrice,
    buyX,
    percentage,
    promo
  ) {
    setCart({
      product,
      type: "changePrice",
      discount: discount,
      discountedPrice: discountedPrice,
      buyX: buyX,
      percentage: percentage,
      promo: promo,
    });
  }

  // useEffect(() => {
  //   // This will log the current path whenever it changes
  //   console.log("Current Path:", location.pathname);
  //   // setCurrentPath(location.pathname);
  // }, [location]);

  // useEffect(() => {
  //   Swal.fire({
  //     text: "Please Zoom Out",
  //   });
  // }, []);

  if (
    location?.pathname?.includes("/machineUI/homePage") ||
    location?.pathname?.includes("/machineUI/category/") ||
    location?.pathname?.includes("/machineUI/product/")
  ) {
    console.log("machine", machine);
    if (!machine) {
      Swal.fire({
        text: "Your Section Is Expired",
        icon: "error",
      }).then(() => {
        history("/Locations");
      });
      return <div>NOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOOO</div>;
    }
  }

  return (
    <div>
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=0.5" />
      </Helmet>
      <div>TESTTESTTESTTESTTESTTESTTESTTESTTESTTEST</div>
      <CartFullModal show={cartFull} setCartFull={setCartFull} />
      <Routes>
        <Route
          path="/home"
          element={
            <Initial
              setThemeColor={setThemeColor}
              setShowCart={setShowCart}
              setlangs={setlangs}
              setMachine={setMachine}
              setProds={setAllProds}
              cleanUp={cleanUp}
            />
          }
        />
        <Route
          path="/homePage"
          element={
            <Home
              changePrice={changePrice}
              themeColor={themeColor}
              showCart={showCart}
              promoRef={promoRef}
              setShowCart={setShowCart}
              add={add}
              cart={cart}
              decreStock={decreStock}
              itemCounter={cartQuantity}
              changeProdPrice={changeProdPrice}
              alterquantity={alterQuantity}
              langs={langs}
              remove={remove}
              setCartFull={setCartFull}
              setlangs={setlangs}
            />
          }
        />
        <Route
          path="/category/:brandOrCate/:catename/:id"
          element={
            <CategoryPage
              closePromoModalRef={closePromoModalRef}
              promoRef={promoRef}
              changePrice={changePrice}
              setlangs={setlangs}
              showCart={showCart}
              setShowCart={setShowCart}
              add={add}
              cart={cart}
              decreStock={decreStock}
              itemCounter={cartQuantity}
              changeProdPrice={changeProdPrice}
              alterquantity={alterQuantity}
              langs={langs}
              remove={remove}
              setCartFull={setCartFull}
            />
          }
        />
        <Route
          path="/product/:machineID/:id/:idx"
          element={
            <DescriptionPage
              closePromoModalRef={closePromoModalRef}
              promoRef={promoRef}
              changePrice={changePrice}
              setlangs={setlangs}
              showCart={showCart}
              setShowCart={setShowCart}
              add={add}
              cart={cart}
              decreStock={decreStock}
              itemCounter={cartQuantity}
              changeProdPrice={changeProdPrice}
              alterquantity={alterQuantity}
              langs={langs}
              remove={remove}
              setCartFull={setCartFull}
            />
          }
        />
      </Routes>
    </div>
  );
};

export default RouteUI;
